var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Icon, InternalNavLink } from '@/ui-toolkit';
/**
 * An {@link InternalNavLink} implementation that displays an arrow next to the name, and defaults to the 'primary' color.
 *
 * This is often used to link between admin areas.
 */
export var ArrowNavLink = function (_a) {
    var color = _a.color, to = _a.to, children = _a.children, icon = _a.icon, target = _a.target;
    return (React.createElement(ZeroPaddingInternalNavLink, { color: color !== null && color !== void 0 ? color : 'primary', link: true, to: to, target: target !== null && target !== void 0 ? target : '_self' },
        children,
        React.createElement(Icon, { name: icon !== null && icon !== void 0 ? icon : 'arrowForward' })));
};
var ZeroPaddingInternalNavLink = styled(InternalNavLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 0;\n"], ["\n    padding: 0;\n"])));
var templateObject_1;
